export default __webpack_public_path__ + "static/media/olSample.734c47e2.png";